






















import { Component, Vue, Prop } from 'vue-property-decorator';
import { ELTABLE_FORMAT } from '@/utils/elTable_formatter';
import { STATUS } from '@/const/status/index';
import { TableColumn } from 'element-ui/types/table-column.d';
@Component<StatusColumn>({
    name: 'StatusColumn',
})
export default class StatusColumn extends Vue {
    private activeValue: STATUS = STATUS.ACTIVE;
    private inactiveValue: STATUS = STATUS.INACTIVE;
    private formatter: (row: any, column: TableColumn) => string = ELTABLE_FORMAT.NumberFormat;
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'center' }) private align!: string;
    @Prop({ type: [String, Number], default: ''  }) private width!: number | string;
    @Prop({ type: [String, Number], default: 80  }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;
    
    private emitChange(v: STATUS, rowList: any[]) {
        this.$nextTick(() => {            
            this.$emit('change', rowList, (v & this.activeValue) === 1);
        })
    }
}
